













import { Component, Prop, Vue } from "vue-property-decorator";
import { IWallet } from "@/interfaces";

@Component
export default class WalletVote extends Vue {
  @Prop({ required: true }) public wallet: IWallet;

  private view = "public";
  private knownWallets: { [key: string]: string };

  get votedDelegate() {
    return this.$store.getters["delegates/byPublicKey"](this.wallet.vote) || {};
  }

  get isVoting() {
    return !!this.wallet.vote;
  }
}
